import api, { manageError } from "config/api";

export const getAllCCs = async () => {
  const response = await api.get(`/assistants/list/cc`);
  return manageError(response);
};

export const getByTypeIdAndNumberId = async (typeId, numberId) => {
  const response = await api.get(`/assistants/cc/${typeId}/${numberId}`);
  return manageError(response);
};
